export const CONTACT_EMAIL = 'contato@fretz.com.br';
export const WHATSAPP_E164 = (process.env.REACT_APP_WHATSAPP_E164 || '').replace(/\D/g, '');

export const SHARED = {
  maxSize: '40×40×40 cm',
  maxWeight: '8 kg',
  doorWait: '15 minutos',
  coverage: 'Grande Goiânia',
  packageRule: 'Só sacolas e pacotes — sem móveis, mudanças ou caminhão',
  doorRule: 'O veículo Fretz estaciona nas proximidades. Encontre-o em até 15 minutos; depois a rota segue.',
  fromPrice: 'R$ 290',
};

export const PLANS = [
  {
    id: 'diario',
    name: 'Plano Diário',
    priceLabel: 'R$ 1.890',
    priceSuffix: '/mês',
    cadence: 'Coleta todos os dias úteis, na rota diária compartilhada',
    sla: 'Entrega em até 36 horas após a coleta',
    slaShort: '36 horas após a coleta',
    stops: 60,
    extraStopLabel: 'R$ 35',
    extraStopValue: 35,
    forWho: 'Lojas, e-commerces e costureiras com fluxo diário de sacolas',
    highlight: true,
    tag: 'Fluxo diário',
  },
  {
    id: 'semanal',
    name: 'Plano Semanal',
    priceLabel: 'R$ 790',
    priceSuffix: '/mês',
    cadence: 'Coleta 1× por semana, em dia fixo — uma rota nesse dia',
    sla: 'Entrega em até 72 horas úteis após a coleta da semana',
    slaShort: '72 horas úteis após a coleta',
    stops: 24,
    extraStopLabel: 'R$ 38',
    extraStopValue: 38,
    forWho: 'Comerciantes que consolidam o volume da semana',
    highlight: false,
    tag: '1× por semana',
  },
  {
    id: 'mensal',
    name: 'Plano Mensal',
    priceLabel: 'R$ 290',
    priceSuffix: '/mês',
    cadence: 'Coleta 1× por mês, em janela agendada, encaixada num dia de rota',
    sla: 'Entrega em até 72 horas úteis após a coleta',
    slaShort: '72 horas úteis após a coleta',
    stops: 8,
    extraStopLabel: 'R$ 45',
    extraStopValue: 45,
    forWho: 'Escritórios de contabilidade, malotes e documentos para lojas pequenas',
    highlight: false,
    tag: 'A partir de',
  },
];

export const planFeatures = (plan) => [
  plan.cadence,
  `${plan.stops} paradas inclusas por mês`,
  `Parada extra ${plan.extraStopLabel}`,
  plan.sla,
  `Pacote máximo ${SHARED.maxSize}, até ${SHARED.maxWeight}`,
  `Cobertura: ${SHARED.coverage}`,
  `Encontre o veículo em até ${SHARED.doorWait}`,
];

export const CITIES = [
  'Goiânia',
  'Aparecida de Goiânia',
  'Senador Canedo',
  'Trindade',
  'Goianira',
  'Hidrolândia',
  'Aragoiânia',
  'Abadia de Goiás',
  'Nerópolis',
  'Guapó',
  'Bela Vista de Goiás',
  'Santo Antônio de Goiás',
];

export const mailtoHref = (subject, body) => {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const qs = params.toString().replace(/\+/g, '%20');
  return `mailto:${CONTACT_EMAIL}${qs ? `?${qs}` : ''}`;
};

export const whatsappHref = (message) => {
  if (!WHATSAPP_E164) return null;
  return `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent(message)}`;
};

export const defaultWhatsappMessage =
  `Olá! Quero contratar um plano Fretz Empresas (Diário, Semanal ou Mensal) na Grande Goiânia.`;

export const NICHES = [
  {
    title: 'Lojas de roupa e costureiras',
    desc: 'Sacolas, tecidos e peças prontas entre ateliê, casa da costureira e loja — no ritmo diário ou semanal.',
    tag: 'Sacolas',
  },
  {
    title: 'E-commerces locais de sacola e pacote',
    desc: 'Pedidos que cabem na mão: caixas, envelopes e kits para o cliente final na Grande Goiânia.',
    tag: 'Pacotes',
  },
  {
    title: 'Confeitarias, bolo de pote e presentes',
    desc: 'Entregas recorrentes de encomendas leves, bem acondicionadas, no ritmo da rota.',
    tag: 'Alimentos leves',
  },
  {
    title: 'Distribuição multi-ponto',
    desc: 'Kits, vinhos, cestas corporativas e brindes para vários endereços no mesmo ciclo, dentro do limite de paradas.',
    tag: 'Vários destinos',
  },
  {
    title: 'Contábil, malote, protocolo e cartório',
    desc: 'Documentos e malotes entre escritório, clientes e cartórios — encaixa bem no Plano Mensal ou Semanal.',
    tag: 'Malote',
  },
  {
    title: 'Lojas médias sem frota eficiente',
    desc: 'Troque o custo fixo de carro + motorista + rota ruim por um plano mensal previsível.',
    tag: 'Operação',
  },
];

export const HOW_IT_WORKS = [
  {
    n: '01',
    title: 'Escolhe o plano',
    desc: 'Diário, Semanal ou Mensal — a partir de R$ 290. Assina e define o ritmo de coleta.',
  },
  {
    n: '02',
    title: 'Solicita as coletas',
    desc: 'Peça coletas pelo app ou WhatsApp. Informe origem, destino e o volume (sacola ou pacote).',
  },
  {
    n: '03',
    title: 'O carro Fretz passa na rota',
    desc: 'A frota identificada faz circuitos compartilhados. Seu pedido entra no dia de rota do plano.',
  },
  {
    n: '04',
    title: 'Encontre o veículo na porta',
    desc: 'O carro estaciona nas proximidades. Alguém precisa encontrar o veículo em até 15 minutos. Depois a rota segue.',
  },
  {
    n: '05',
    title: 'Entrega no destino',
    desc: 'Diário: até 36 horas após a coleta. Semanal e Mensal: até 72 horas úteis após a coleta.',
  },
];

export const WHY_CHEAPER = [
  {
    title: 'Rota compartilhada',
    desc: 'Várias empresas usam o mesmo veículo no mesmo circuito. Você não paga um carro exclusivo ocioso.',
  },
  {
    title: 'Espera limitada a 15 minutos',
    desc: 'O motorista não fica na porta. Quem envia ou recebe encontra o veículo. Essa regra reduz o custo de cada parada.',
  },
  {
    title: 'Sem frota própria parada',
    desc: 'Salário, combustível, manutenção e tempo perdido em trânsito deixam de ser custo fixo da sua empresa.',
  },
];

export const FAQS = [
  {
    q: 'O que é a Fretz?',
    a: 'A Fretz é um serviço B2B de rotas mensais na Grande Goiânia. Operamos uma frota identificada em circuitos compartilhados. Sua empresa substitui o frete próprio (carro + motorista + rota ineficiente) por um plano mensal. Não somos marketplace de picape, mudança ou caminhão.',
  },
  {
    q: 'Quais são os planos?',
    a: 'Três planos: Diário (R$ 1.890/mês, coleta em dias úteis, 60 paradas, entrega em até 36 horas após a coleta, extra R$ 35), Semanal (R$ 790/mês, coleta 1× por semana em dia fixo, 24 paradas, 72 horas úteis após a coleta, extra R$ 38) e Mensal (R$ 290/mês, coleta 1× por mês, 8 paradas, 72 horas úteis após a coleta, extra R$ 45).',
  },
  {
    q: 'O que conta como uma parada?',
    a: 'Cada ponto em que o veículo Fretz precisa parar para coletar ou entregar. Uma coleta em A e uma entrega em B são duas paradas. Distribuição para vários endereços consome uma parada por destino. Paradas além das inclusas no plano são cobradas no extra do próprio plano.',
  },
  {
    q: 'Por que vocês pedem 15 minutos na porta?',
    a: 'O veículo estaciona nas proximidades. Quem envia ou recebe deve ir até o carro, em até 15 minutos. Se ninguém aparecer, a rota continua. Essa disciplina é o que permite um preço mensal baixo: o carro não fica parado esperando.',
  },
  {
    q: 'Qual o prazo de entrega de cada plano?',
    a: 'Plano Diário: entrega em até 36 horas após a coleta (esse prazo cobre coletas no fim do dia). Planos Semanal e Mensal: até 72 horas úteis após a coleta daquele ciclo.',
  },
  {
    q: 'O que posso enviar?',
    a: 'Apenas sacolas e pacotes: no máximo 40×40×40 cm e até 8 kg. Roupas, tecidos, kits, bolo de pote bem embalado, presentes, malotes e encomendas semelhantes. Não transportamos móveis, eletrodomésticos, colchões, mudanças nem carga de caminhão.',
  },
  {
    q: 'Vocês fazem mudança, picape ou caminhão?',
    a: 'Não. A Fretz não é marketplace de frete avulso nem de mudanças. O produto são só os planos mensais de rota para pacotes leves.',
  },
  {
    q: 'Onde vocês atendem?',
    a: 'Grande Goiânia (Região Metropolitana): Goiânia, Aparecida de Goiânia, Senador Canedo, Trindade, Goianira e municípios vizinhos da RM.',
  },
  {
    q: 'Como contrato?',
    a: 'Preencha o formulário “Quero Fretz Empresas”, escreva para contato@fretz.com.br ou fale no WhatsApp. Informe o plano de interesse. Nossa equipe confirma cobertura, volume e ativa a assinatura.',
  },
  {
    q: 'E se eu passar das paradas inclusas?',
    a: 'As paradas excedentes são cobradas no fechamento do mês: R$ 35 no Diário, R$ 38 no Semanal e R$ 45 no Mensal.',
  },
];
